<template>
  <div>
    <app-loader v-show="$store.state.appConfig.showLoader" />
    <div
      v-if="showMessage"
      class="mobileWrapper floatCss"
    >
      <div class="Purchaserdetails-section floatCss">
        <b-row>
          <b-col cols="12">
            <div class="pd-tittle floatCss">
              <h3>Purchaser details</h3>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div class="alert-block floatCss">
              <div class="alert-wrapper floatCss">
                <div class="alert-icon">
                  <img :src="alertIcon">
                </div>
                <div class="alert-content">
                  <div class="alertInfoInner floatCss">
                    <p>Just a reminder — this Transfer Request will expire after <strong>{{ dateFormatWithFormatParam(transferRequest.expiresAt, 'MMM DD, YYYY') }}, at {{ dateFormatWithFormatParam(transferRequest.expiresAt, 'hh:mm A') }}</strong>, so please complete it before then.</p>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="isPurchaserComplete">
          <b-col cols="12">
            <div class="purchaseDetails-Item-single pr-complete floatCss">
              <div class="pd-Item-top floatCss">
                <div class="pd-tittle-left floatCss">
                  Purchaser details
                </div>
                <span class="rq-text complte-rq">Completed</span>
              </div>
              <div class="pd-Item-mid floatCss">
                <p>{{ transferRequest.newPurchaser ? transferRequest.newPurchaser.name : '' }}</p>
              </div>
              <div class="pd-Item-bottom floatCss">
                <b-button
                  :to="{ name: 'file-transfer-purchaser-details-singpass', params: { token: $route.params.token } }"
                  class="pd-btn"
                >
                  Edit details
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="12">
            <div class="purchaseDetails-Item-single floatCss">
              <div class="pd-Item-top floatCss">
                <div class="pd-tittle-left floatCss">
                  Purchaser details
                </div>
                <span class="rq-text">Required</span>

              </div>
              <div class="pd-Item-mid floatCss">
                <p>Enter your details</p>
              </div>
              <div class="pd-Item-bottom floatCss">
                <b-button
                  :to="{ name: 'file-transfer-purchaser-details-singpass', params: { token: $route.params.token } }"
                  class="pd-btn"
                >
                  Provide details
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="isPersonalDataComplete">
          <b-col cols="12">
            <div class="purchaseDetails-Item-single pr-complete floatCss">
              <div class="pd-Item-top floatCss">
                <div class="pd-tittle-left floatCss">
                  Personal data consent
                </div>
                <span class="rq-text complte-rq">Completed</span>
              </div>
              <div class="pd-Item-mid floatCss">
                <p>Yes, I agree</p>
              </div>
              <div class="pd-Item-bottom floatCss">
                <b-button
                  :to="{ name: 'file-transfer-personal-data-consent', params: { token: $route.params.token } }"
                  class="pd-btn"
                >
                  Change
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="12">
            <div class="purchaseDetails-Item-single floatCss">
              <div class="pd-Item-top floatCss">
                <div class="pd-tittle-left floatCss">
                  Personal data consent
                </div>
                <span class="rq-text">Required</span>
              </div>
              <div class="pd-Item-mid floatCss">
                <p>Do you consent to the use of your personal data?</p>
              </div>
              <div class="pd-Item-bottom floatCss">
                <b-button
                  :to="{ name: 'file-transfer-personal-data-consent', params: { token: $route.params.token } }"
                  class="pd-btn"
                >
                  Agree and continue
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="isTermsComplete">
          <b-col cols="12">
            <div class="purchaseDetails-Item-single pr-complete floatCss">
              <div class="pd-Item-top floatCss">
                <div class="pd-tittle-left floatCss">
                  Terms and conditions
                </div>
                <span class="rq-text complte-rq">Completed</span>
              </div>
              <div class="pd-Item-mid floatCss">
                <p>Yes, I agree</p>
              </div>
              <div class="pd-Item-bottom floatCss">
                <b-button
                  :to="{ name: 'file-transfer-terms-consent', params: { token: $route.params.token } }"
                  class="pd-btn"
                >
                  Change
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="12">
            <div class="purchaseDetails-Item-single floatCss">
              <div class="pd-Item-top floatCss">
                <div class="pd-tittle-left floatCss">
                  Terms and conditions
                </div>
                <span class="rq-text">Required</span>
              </div>
              <div class="pd-Item-mid floatCss">
                <p>Do you agree to the terms and conditions?</p>
              </div>
              <div class="pd-Item-bottom floatCss">
                <b-button
                  :to="{ name: 'file-transfer-terms-consent', params: { token: $route.params.token } }"
                  class="pd-btn"
                >
                  Agree and continue
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="isMarketingComplete">
          <b-col cols="12">
            <div class="purchaseDetails-Item-single pr-complete floatCss">
              <div class="pd-Item-top floatCss">
                <div class="pd-tittle-left floatCss">
                  Marketing data consent
                </div>
                <span class="rq-text complte-rq">Completed</span>
              </div>
              <div class="pd-Item-mid floatCss">
                <p v-if="marketingOptOut">
                  Opt out of advertising and promotional
                </p>
                <p v-else>
                  I want to receive advertising and promotional material
                </p>
              </div>
              <div class="pd-Item-bottom floatCss">
                <b-button
                  :to="{ name: 'file-transfer-marketing-data-consent', params: { token: $route.params.token } }"
                  class="pd-btn"
                >
                  Change
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="12">
            <div class="purchaseDetails-Item-single floatCss">
              <div class="pd-Item-top floatCss">
                <div class="pd-tittle-left floatCss">
                  Marketing data consent
                </div>
                <span>Optional</span>
              </div>
              <div class="pd-Item-mid floatCss">
                <p>Do you want to <strong>opt out</strong> of marketing communications?</p>
              </div>
              <div class="pd-Item-bottom floatCss">
                <b-button
                  :to="{ name: 'file-transfer-marketing-data-consent', params: { token: $route.params.token } }"
                  class="pd-btn"
                >
                  Review this
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="Purchaserdetails-bottom floatCss">
        <b-row>
          <b-col
            cols="6"
            md="6"
            lg="6"
          >
            <b-button
              class="pr-btn-1"
              @click="saveDraft"
            >
              Save as draft
            </b-button>
          </b-col>
          <b-col
            cols="6"
            md="6"
            lg="6"
          >
            <b-button
              class="pr-btn-2"
              :disabled="!isSubmitReady"
              @click="showSignModal = true"
            >
              Submit
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- Sign overlay -->
    <div
      v-if="showSignModal"
      class="ft-sign-overlay"
    >
      <div class="ft-sign-card-header">
        <b-button
          class="pdc-btn-1"
          @click="showSignModal = false"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"
              fill="#6A5E32"
            />
          </svg>
        </b-button>
      </div>
      <div class="ft-sign-card">
        <div class="ft-sign-card-body">
          <h3>Sign here</h3>
          <p>Please sign to confirm approval.</p>
          <div class="ft-sign-pad">
            <vue-signature-pad
              ref="signaturePad"
              width="100%"
              height="100%"
              :options="signatureOptions"
            />
          </div>
        </div>
        <div class="ft-sign-card-footer">
          <b-button
            class="ft-sign-text-btn"
            @click="clearSignature"
          >
            Clear
          </b-button>
          <b-button
            class="ft-sign-text-btn ft-sign-done-btn"
            @click="saveSignature"
          >
            Done
          </b-button>
        </div>
      </div>
    </div>

    <!-- Confirm submit overlay -->
    <div
      v-if="showConfirmModal"
      class="ft-sign-overlay ft-sign-confirm-overlay mini_modal"
    >
      <div class="ft-sign-card">
        <div class="ft-sign-card-body">
          <h3>Submit this request?</h3>
          <p>
            You are about to submit your details for the
            {{ transferRequest.transferType === 'ownership' ? 'Transfer of Ownership' : 'Change of Purchaser' }}
            of <strong>File {{ transferRequest.fileNo }} - {{ transferRequest.nvsFileType }} ({{ transferRequest.lotLocation }})</strong>.
          </p>
          <div class="ft-sign-preview">
            <img
              v-if="customerSignature"
              :src="customerSignature"
              class="ft-sign-preview-img"
            >
            <b-button
              class="re-sign"
              @click="resign"
            >
              Tap to resign
            </b-button>
          </div>
        </div>
        <div class="ft-sign-card-footer">
          <b-button
            class="pr-btn-1 ft-confirm-btn"
            @click="showConfirmModal = false"
          >
            Cancel
          </b-button>
          <b-button
            class="pr-btn-2 ft-confirm-btn"
            @click="submitAll"
          >
            Yes, proceed
          </b-button>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-draft"
      v-model="showDraftModal"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      dialog-class="draft-modal mini_modal"
    >
      <div class="modal-content-wrapper">
        <h3>Your request has been saved as a draft.</h3>
        <p>
          Please note that this Transfer Request will expire on
          <strong>{{ dateFormatWithFormatParam(transferRequest.expiresAt, 'MMM DD, YYYY') }}, at {{ dateFormatWithFormatParam(transferRequest.expiresAt, 'hh:mm A') }}</strong>.
          Kindly complete your submission before the deadline to ensure a smooth process.
        </p>
      </div>
      <div class="modal-content-bottom">
        <b-button
          class="pr-btn-3"
          @click="showDraftModal = false"
        >
          Complete now
        </b-button>
        <b-button
          class="pr-btn-4"
          @click="finishLater"
        >
          Finish later
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BModal,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppLoader from '../AppLoader.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BModal,
    AppLoader,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      agentPic: require('@/assets/images/file-transfer/agent-photo.png'),
      // eslint-disable-next-line global-require
      successIcon: require('@/assets/images/file-transfer/success-icon.svg'),
      // eslint-disable-next-line global-require
      rejectIcon: require('@/assets/images/file-transfer/reject-icon.svg'),
      // eslint-disable-next-line global-require
      alertIcon: require('@/assets/images/file-transfer/alert-icon.svg'),
      showMessage: false,
      tokenDetail: {},
      transferRequest: {},
      packageName: '',
      titleText: 'Change of Purchaser',
      showDraftModal: false,
      showSignModal: false,
      showConfirmModal: false,
      customerSignature: '',
      signatureOptions: {
        penColor: '#000000',
        onBegin: () => { this.$refs.signaturePad.resizeCanvas() },
      },
      // tracks which steps have local (unsaved) draft data
      localDraft: {
        purchaser: null,
        personalConsent: null,
        terms: null,
        marketing: null,
      },
    }
  },
  computed: {
    isPurchaserComplete() {
      return this.transferRequest.purchaserStep || !!this.localDraft.purchaser
    },
    isPersonalDataComplete() {
      return this.transferRequest.personalDataConsentStep || !!this.localDraft.personalConsent
    },
    isTermsComplete() {
      return this.transferRequest.termsConsentStep || !!this.localDraft.terms
    },
    isMarketingComplete() {
      return this.transferRequest.marketingDataConsentStep || !!this.localDraft.marketing
    },
    marketingOptOut() {
      if (this.localDraft.marketing) return this.localDraft.marketing.status === 'accepted'
      return this.transferRequest.marketingDataConsent
    },
    isSubmitReady() {
      return this.isPurchaserComplete && this.isPersonalDataComplete && this.isTermsComplete
    },
  },
  beforeMount() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      const { token } = this.$route.params
      if (!token) return
      this.$http.get('front-end/file-transfer/file-detail', { params: { token } })
        .then(response => {
          if (response.data.success) {
            if (response.data.validToken) {
              this.tokenDetail = response.data.token || {}
              this.transferRequest = response.data.transferRequest || {}
              if (this.transferRequest.transferType === 'ownership') {
                this.titleText = 'Transfer of ownership'
              }
              if (this.transferRequest.currentStatus === 'Pending NP') {
                this.packageName = response.data.packageName
                this.showMessage = true
                const purchaserRaw = localStorage.getItem('fileTransferDraft_purchaser')
                const personalConsentRaw = localStorage.getItem('fileTransferDraft_personalConsent')
                const termsRaw = localStorage.getItem('fileTransferDraft_terms')
                const marketingRaw = localStorage.getItem('fileTransferDraft_marketing')
                if (purchaserRaw) this.localDraft.purchaser = JSON.parse(purchaserRaw)
                if (personalConsentRaw) this.localDraft.personalConsent = JSON.parse(personalConsentRaw)
                if (termsRaw) this.localDraft.terms = JSON.parse(termsRaw)
                if (marketingRaw) this.localDraft.marketing = JSON.parse(marketingRaw)
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'You have already completed this step',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Expired link',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    clearLocalDrafts() {
      localStorage.removeItem('fileTransferDraft_purchaser')
      localStorage.removeItem('fileTransferDraft_personalConsent')
      localStorage.removeItem('fileTransferDraft_terms')
      localStorage.removeItem('fileTransferDraft_marketing')
      this.localDraft.purchaser = null
      this.localDraft.personalConsent = null
      this.localDraft.terms = null
      this.localDraft.marketing = null
    },
    buildDraftPayload() {
      const { token } = this.$route.params
      const payload = { token, transferRequest: this.transferRequest._id }
      if (this.localDraft.purchaser) payload.purchaser = this.localDraft.purchaser
      if (this.localDraft.personalConsent) payload.personalConsent = this.localDraft.personalConsent
      if (this.localDraft.terms) payload.terms = this.localDraft.terms
      if (this.localDraft.marketing) payload.marketing = this.localDraft.marketing
      return payload
    },
    async saveDraft() {
      const payload = this.buildDraftPayload()
      const hasNewData = payload.purchaser || payload.personalConsent || payload.terms || payload.marketing
      if (!hasNewData) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'No new changes to save',
            icon: 'InfoIcon',
            variant: 'warning',
          },
        })
        return
      }
      try {
        const response = await this.$http.post('front-end/file-transfer/save-draft', payload)
        if (response.data.success) {
          this.clearLocalDrafts()
          this.fetchData()
          this.showDraftModal = true
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: (error.data && error.data.message) || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature()
    },
    async resign() {
      this.customerSignature = null
      this.showConfirmModal = false
      this.showSignModal = true
      await this.$nextTick()
      this.$refs.signaturePad.clearSignature()
    },
    saveSignature() {
      const { data, isEmpty } = this.$refs.signaturePad.saveSignature()
      if (isEmpty) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Please sign before proceeding',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        })
        return
      }
      this.customerSignature = data
      this.showSignModal = false
      this.showConfirmModal = true
    },
    finishLater() {
      this.showDraftModal = false
      this.$router.push({ name: 'file-transfer-landing', params: { token: this.$route.params.token } })
    },
    async submitAll() {
      const payload = this.buildDraftPayload()
      payload.signature = this.customerSignature
      try {
        const response = await this.$http.post('front-end/file-transfer/submit', payload)
        if (response.data.success) {
          this.clearLocalDrafts()
          this.showConfirmModal = false
          this.$router.push({ name: 'file-transfer-completed', params: { token: this.$route.params.token } })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: (error.data && error.data.message) || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
  },
}
</script>
